// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #000000, #ecf0f1",
  firstName: "Luiz Felipe",
  middleName: "",
  lastName: "Lopes",
  message: "Full-Stack Developer · Laravel · React · Azure · 10+ yrs · ex-Accenture · ex-Reply · Open to remote roles",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/luizfelipelopes",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/lfelipeclopes/",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/luizfelipelopes/",
    },

  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/photo-profile2.png"),
  imageSize: 375,
  message:
    "Full-Stack Developer with 10+ years building scalable, maintainable web applications in PHP/Laravel and React. Certified in Azure (Microsoft Certified: Azure Fundamentals) with hands-on experience deploying and integrating cloud services. Previously at Accenture and Reply — recognized three times with the 'Distinctive Achievement' award at Accenture for measurable impact on enterprise-level projects. Core stack: Laravel · React · Tailwind CSS · Azure · REST APIs · MySQL / MariaDB / Oracle. Practices: OOP · MVC · TDD / Unit Testing · Clean Code · CI/CD · Docker · SCRUM · Azure DevOps. Also worked with: RabbitMQ · jQuery · WordPress · Data Structures. I thrive in cross-functional teams, take ownership of technical decisions, and consistently deliver under tight deadlines. Open to remote-first international opportunities.",
  resume: "https://docs.google.com/document/d/1ZSX9bRdyxttv0VoG_IyeXc70x8SqPnLk/edit?usp=sharing&ouid=109917751422031829028&rtpof=true&sd=true",
};

const testimonials = {
  show: true,
  heading: "Testimonials",

  data: [
    {
      name: 'Nilma Nayara Neves',
      local: 'Diamantina - MG',
      imageLink: require("../assets/img/testimonials/testimonial-nayara.jpeg"),
      message: 'Great. Luiz was very professional and responsible with everything I asked, I can only thank him for the patience and dedication he had with me. He fulfilled our contract to the letter and even went beyond what I asked, it was great, congratulations!',

    },
    {
      name: 'Vitória Alves',
      local: 'Curvelo - MG',
      imageLink: require("../assets/img/testimonials/testimonial-vitoria-alves.jpeg"),
      message: "Incredible. Much more than I expected, the website was super functional, super practical, Luiz Felipe was super available and managed to create my entire website in 1 week! I'm very grateful, it was a great job. It was worth the money invested.",
    },
  ],
  imageSize: 100,
  showPic: true
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
// const repos = {
//   show: true,
//   heading: "Recent Projects",
//   gitHubUsername: "luizfelipelopes", //i.e."johnDoe12Gh"
//   reposLength: 4,
//   specificRepos: [],
// };

const repos = {};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    {
      img: require("../editable-stuff/hashirshoaeb.png"),
      label: "First slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
    {
      img: require("../editable-stuff/hashirshoaeb.png"),
      label: "Second slide label",
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum."
    },
  ],
  imageSize: {
    width: "615",
    height: "450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Laravel", value: 70 },
    { name: "PHP", value: 90 },
    { name: "Node Js", value: 60 },
    { name: "Wordpress", value: 60 },
    { name: "React Native", value: 55 },
    { name: "IA", value: 60 },

    { name: "React", value: 70 },
    { name: "Javascript", value: 90 },
    { name: "Python", value: 35 },
    { name: "HTML/CSS", value: 88 },
    { name: "Azure", value: 85 },
    { name: "SQL", value: 75 },

  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 79 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 90 },
    { name: "Creativity", value: 70 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "If you want get in touch, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "lfelipelopesti@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Fullstack Developer',// Here Add Company Name
      companylogo: require('../assets/img/icts.png'),
      date: 'Apr 2025 – Ago 2025',

    },
    {
      role: 'Software Engineer',// Here Add Company Name
      companylogo: require('../assets/img/accenture.jpeg'),
      date: 'Jun 2021 – Apr 2025',

    },
    {
      role: 'Developer Analyst',
      companylogo: require('../assets/img/reply.jpg'),
      date: 'Jan 2020 – Jun 2021',
    },
    {
      role: 'Web Developer',
      companylogo: require('../assets/img/vale-consulting.png'),
      date: 'Nov 2016 – Nov 2018',
      title: 'Vale Consulting'
    },
  ]
}

const portfolios = {
  show: true,
  heading: "Portfolios",
  mobile: [
    {
      name: 'App Saudável',// Here Add Company Name
      image: require('../assets/img/portfolio/appsaudavel.png'),
      // linkAndroid: 'https://play.google.com/store/apps/details?id=com.appsaudavel',
      // linkIos: 'https://apps.apple.com/app/app-saud%C3%A1vel/id6446791063',
      github: 'https://github.com/luizfelipelopes/appsaudavel',
      language: 'Js (React Native)'

    },
    {
      name: 'App Gabadi',
      image: require('../assets/img/portfolio/appgabadi.png'),
      // linkAndroid: 'https://play.google.com/store/apps/details?id=com.appgabadi',
      // linkIos: 'https://apps.apple.com/br/app/gabadi/id6459659036',
      github: 'https://github.com/luizfelipelopes/appgabadi',
      language: 'Js (React Native)'
    },
  ],
  web: [
    {
      name: 'Portfólio',// Here Add Company Name
      image: require('../assets/img/portfolio/portfolio.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/',
      language: 'PHP'
    },
    {
      name: 'Cardápio Di Pizzaria',
      image: require('../assets/img/portfolio/cardapio.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/cardapio/&theme=pizzaria',
      language: 'PHP'
    },
    {
      name: 'Di Pizzaria',
      image: require('../assets/img/portfolio/pizzaria.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/&theme=pizzaria',
      language: 'PHP'
    },
    {
      name: 'Conferência Avante',
      image: require('../assets/img/portfolio/ingresso.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/&theme=ingresso',
      language: 'PHP'
    },
    {
      name: 'Gabadi Online',
      image: require('../assets/img/portfolio/blog-cristao.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/&theme=blog-cristao',
      language: 'PHP'
    },
    {
      name: 'Nilma Nayara Nutri',
      image: require('../assets/img/portfolio/blog-nutricao.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/&theme=blog-saude',
      language: 'PHP'
    },
    {
      name: 'Treinamento Real (Landing Page)',
      image: require('../assets/img/portfolio/landing-page.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/treinamentoreal/&theme=blog-saude',
      language: 'PHP'
    },
    {
      name: 'Cet-Rhema',
      image: require('../assets/img/portfolio/ead.png'),
      link: 'https://portfolio-php-9745e96b81dc.herokuapp.com/&theme=ead',
      language: 'PHP'
    },
  ],
  frontend: [
    {
      name: 'Currency Converter',
      image: require('../assets/img/portfolio/currency-converter.png'),
      link: 'https://currency-converter-ten-beryl-94.vercel.app/',
      github: 'https://github.com/luizfelipelopes/currency-converter',
      language: 'React Js, Typescript'
    },
    {
      name: 'Ring Siren',
      image: require('../assets/img/portfolio/ring-siren.png'),
      link: 'https://ring-siren.vercel.app/',
      github: 'https://github.com/luizfelipelopes/ring-siren',
      language: 'React Js, Typescript'
    },
    {
      name: 'Pokédex',
      image: require('../assets/img/portfolio/pokedex-fe.png'),
      // link: 'https://ring-siren.vercel.app/',
      github: 'https://github.com/luizfelipelopes/pokedex',
      language: 'React Js, Typescript'
    },
  ],
  backend: [
    {
      name: 'Currency Quote Conversion API',
      image: require('../assets/img/portfolio/currency-quotes.png'),
      github: 'https://github.com/luizfelipelopes/currency-quotes',
      language: 'Node (Nest Js)'
    },
    {
      name: 'Import More than One Million Rows to Database Efficiently',
      image: require('../assets/img/portfolio/import-million-rows-with-validations.png'),
      github: 'https://github.com/luizfelipelopes/import-million-rows-with-validations',
      language: 'Laravel'
    },
    {
      name: 'Pokedex',
      image: require('../assets/img/portfolio/pokedex.png'),
      github: 'https://github.com/luizfelipelopes/pokedex',
      language: 'Laravel'
    },
    {
      name: 'Recipes API - Recipes Management',
      image: require('../assets/img/portfolio/recepies-api.png'),
      github: 'https://github.com/luizfelipelopes/recepies-api',
      language: 'Laravel, Blade'
    },
    {
      name: 'Hospital Management API',
      image: require('../assets/img/portfolio/hospital-management.png'),
      github: 'https://github.com/luizfelipelopes/hospital-management',
      language: 'Laravel, Blade'
    },
    {
      name: 'Blogify',
      image: require('../assets/img/portfolio/blogify.png'),
      github: 'https://github.com/luizfelipelopes/blogify',
      language: 'Laravel, Blade'
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

const uiText = {
  nav: {
    projects: "Projects",
    portfolios: "Portfolios",
    resume: "Resume",
    about: "About",
    skills: "Skills",
    experiences: "Experiences",
    testimonials: "Testimonials",
  },
  mainBody: {
    ctaAbout: "More about me",
  },
  about: {
    resumeButton: "Resume",
  },
  skills: {
    technicalTab: "Technical Skills",
    softTab: "Soft Skills",
  },
  portfolios: {
    backendTab: "Back-end",
    frontendTab: "Front-end",
    mobileTab: "Mobile",
    webTab: "Web",
    stackLabel: "Stack",
    androidLabel: "Android",
    iosLabel: "iOS",
    siteLabel: "Site",
    githubLabel: "Github",
  },
};

const contentByLanguage = {
  en: {
    navBar,
    mainBody: {
      ...mainBody,
      message:
        "Full-Stack Developer · Laravel · React · Azure · 10+ yrs · ex-Accenture · ex-Reply · Open to remote roles",
    },
    about,
    repos,
    skills,
    leadership,
    getInTouch,
    experiences,
    portfolios,
    testimonials,
    uiText,
  },
  "pt-BR": {
    navBar,
    mainBody: {
      ...mainBody,
      message:
        "Desenvolvedor Full-Stack · Laravel · React · Azure · +10 anos · ex-Accenture · ex-Reply · Aberto a oportunidades remotas",
    },
    about: {
      ...about,
      heading: "Sobre Mim",
      message:
        "Desenvolvedor Full-Stack com mais de 10 anos construindo aplicaçoes web escalaveis e faceis de manter com PHP/Laravel e React. Certificado em Azure (Microsoft Certified: Azure Fundamentals), com experiencia pratica em deploy e integraçao de serviços em nuvem. Atuei na Accenture e na Reply, sendo reconhecido tres vezes com o premio 'Distinctive Achievement' na Accenture por impacto mensuravel em projetos de grande porte. Stack principal: Laravel, React, Tailwind CSS, Azure, REST APIs, MySQL, MariaDB e Oracle. Praticas: OOP, MVC, TDD, testes unitarios, Clean Code, CI/CD, Docker, SCRUM e Azure DevOps. Tambem atuei com RabbitMQ, jQuery, WordPress e estruturas de dados. Gosto de trabalhar com times multidisciplinares, assumo responsabilidade por decisoes tecnicas e entrego com consistencia mesmo em prazos curtos. Aberto a oportunidades internacionais com foco remoto.",
    },
    repos: {
      ...repos,
      heading: "Projetos Recentes",
    },
    skills: {
      ...skills,
      heading: "Habilidades",
      softSkills: [
        { name: "Foco em objetivos", value: 80 },
        { name: "Colaboraçao", value: 79 },
        { name: "Positividade", value: 75 },
        { name: "Adaptabilidade", value: 85 },
        { name: "Resoluçao de problemas", value: 75 },
        { name: "Empatia", value: 90 },
        { name: "Organizaçao", value: 90 },
        { name: "Criatividade", value: 70 },
      ],
    },
    leadership: {
      ...leadership,
      heading: "Liderança",
    },
    getInTouch: {
      ...getInTouch,
      heading: "Entre em Contato",
      message:
        "Se voce quiser falar comigo, tiver alguma duvida ou apenas quiser dar um oi, fique a vontade para me enviar um e-mail em",
    },
    experiences: {
      ...experiences,
      heading: "Experiencias",
      data: experiences.data.map((item) => ({
        ...item,
        date: item.date
          .replace("Apr", "Abr")
          .replace("Ago", "Ago")
          .replace("Jun", "Jun")
          .replace("Nov", "Nov")
          .replace("Jan", "Jan"),
      })),
    },
    portfolios: {
      ...portfolios,
      heading: "Portfolios",
    },
    testimonials: {
      ...testimonials,
      heading: "Depoimentos",
      data: [
        {
          ...testimonials.data[0],
          message:
            "Excelente. O Luiz foi muito profissional e responsavel com tudo que pedi. So tenho a agradecer pela paciencia e dedicaçao que teve comigo. Cumpriu nosso contrato a risca e ainda foi alem do que solicitei. Foi otimo, parabens!",
        },
        {
          ...testimonials.data[1],
          message:
            "Incrivel. Muito alem do que eu esperava: o site ficou super funcional e pratico. O Luiz Felipe foi super disponivel e conseguiu criar meu site inteiro em 1 semana. Sou muito grata, foi um grande trabalho. Valeu cada investimento.",
        },
      ],
    },
    uiText: {
      nav: {
        projects: "Projetos",
        portfolios: "Portfolios",
        resume: "Curriculo",
        about: "Sobre",
        skills: "Habilidades",
        experiences: "Experiencias",
        testimonials: "Depoimentos",
      },
      mainBody: {
        ctaAbout: "Mais sobre mim",
      },
      about: {
        resumeButton: "Curriculo",
      },
      skills: {
        technicalTab: "Habilidades Tecnicas",
        softTab: "Soft Skills",
      },
      portfolios: {
        backendTab: "Back-end",
        frontendTab: "Front-end",
        mobileTab: "Mobile",
        webTab: "Web",
        stackLabel: "Stack",
        androidLabel: "Android",
        iosLabel: "iOS",
        siteLabel: "Site",
        githubLabel: "Github",
      },
    },
  },
};

const defaultLanguage = "en";
const availableLanguages = ["en", "pt-BR"];

const getContentByLanguage = (language = defaultLanguage) =>
  contentByLanguage[language] || contentByLanguage[defaultLanguage];

export {
  navBar,
  mainBody,
  about,
  repos,
  skills,
  leadership,
  getInTouch,
  experiences,
  portfolios,
  testimonials,
  defaultLanguage,
  availableLanguages,
  contentByLanguage,
  getContentByLanguage,
};
